import { Skeleton } from 'primereact/skeleton';
import classes from './loaderStyle.module.scss';

const GridSkeletalLoader = () => {
  return (
    <div className={classes.tabSkeletonSkeleton}>
      <div className={classes.tabSkeletonTable}>
        <Skeleton height="38rem"></Skeleton>
      </div>
    </div>
  );
};

export default GridSkeletalLoader;
